import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { env } from '../../../environments/environment';
import { map, Observable } from 'rxjs';
import { Info } from './typings';

@Injectable({
  providedIn: 'root'
})
export class InfoService {

  constructor(private http: HttpClient) { }

  getInfoData(): Observable<Info> {
    
    //const urlWithQuery = `${env.API.info_api_url}?isExternal=false`; // Append the query parameter  

    return this.http.get<Info[]>(env.API.info_api_url).pipe(
      map((response: Info[]) => response?.[0])
    );
  }
}
